(function(){
  // THE KIT DEALER - Mobile collection grid fix v3 (Bulletproof - Safari safe)
  if(window.innerWidth>768)return;
  function fixGrid(){
    // 1. Wipe inline transform on slick-track (CSS !important can't beat inline styles)
    document.querySelectorAll('.collections-list .slick-track').forEach(function(t){
      t.style.transform='none';t.style.width='';t.style.transition='none';
    });
    // 2. Reset inline width/float on slick-slides
    document.querySelectorAll('.collections-list .slick-slide').forEach(function(s){
      s.style.width='';s.style.float='';s.style.display='';
    });
    // 3. Unhide aria-hidden slides (slick hides non-visible ones)
    document.querySelectorAll('.collections-list .slick-slide[aria-hidden="true"]').forEach(function(s){
      s.removeAttribute('aria-hidden');s.style.visibility='';
    });
    // 4. Hide arrows
    document.querySelectorAll('.collections-list .slick-prev,.collections-list .slick-next').forEach(function(a){
      a.style.display='none';
    });
    // 5. Try jQuery unslick as a clean-up (belt + braces)
    if(typeof jQuery!=='undefined'){
      document.querySelectorAll('.collections-list.slick-initialized').forEach(function(el){
        try{jQuery(el).slick('unslick');}catch(e){}
      });
    }
  }
  // Run at multiple intervals to catch any device/network timing
  [0,100,250,500,800,1200,2000,3500].forEach(function(t){setTimeout(fixGrid,t);});
  // MutationObserver: catches slick initialising AFTER our timeouts
  var obs=new MutationObserver(function(muts){
    var need=false;
    muts.forEach(function(m){
      if(m.attributeName==='class'&&m.target.classList&&m.target.classList.contains('slick-initialized'))need=true;
      if(m.type==='childList'&&m.addedNodes.length)need=true;
    });
    if(need)setTimeout(fixGrid,0);
  });
  function startObs(){
    document.querySelectorAll('.collections-list').forEach(function(el){
      obs.observe(el,{attributes:true,attributeFilter:['class'],childList:true,subtree:true});
    });
  }
  document.readyState==='loading'
    ?document.addEventListener('DOMContentLoaded',startObs)
    :startObs();
  window.addEventListener('load',function(){fixGrid();setTimeout(fixGrid,500);});
})();

// THE KIT DEALER — Hide drop products from predictive search
// Works by patching fetch to add unavailable_products=hide (set drop products to 0 inventory)
(function(){
  var orig=window.fetch;
  window.fetch=function(url,opts){
    if(typeof url==='string'&&url.includes('/search/suggest')&&!url.includes('unavailable_products')){
      url+=(url.includes('?')?'&':'?')+'resources%5Boptions%5D%5Bunavailable_products%5D=hide';
    }
    return orig.apply(this,arguments);
  };
})();

// THE KIT DEALER — Klaviyo scroll-lock safety net (added 2026-06-12 mobile audit)
// Klaviyo's fullscreen signup form adds 'klaviyo-prevent-body-scrolling' to <body>
// while it is open; the class has been seen to outlive the closed form on mobile,
// leaving the page unscrollable. If the class is present but no Klaviyo-sized
// overlay is actually visible for ~3s, remove it so scrolling always comes back.
(function(){
  var misses=0;
  function overlayVisible(){
    var els=document.querySelectorAll('div.needsclick,div[class*="kl-private"]');
    for(var i=0;i<els.length;i++){
      var cs=getComputedStyle(els[i]);
      if(cs.position!=='fixed')continue;
      var z=parseInt(cs.zIndex,10);
      if(isNaN(z)||z<9000)continue;
      if(cs.display==='none'||cs.visibility==='hidden'||parseFloat(cs.opacity)<0.05)continue;
      var r=els[i].getBoundingClientRect();
      if(r.width>=window.innerWidth*0.7&&r.height>=window.innerHeight*0.4)return true;
    }
    return false;
  }
  setInterval(function(){
    if(!document.body.classList.contains('klaviyo-prevent-body-scrolling')){misses=0;return;}
    if(overlayVisible()){misses=0;return;}
    if(++misses>=2){
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
      misses=0;
    }
  },1500);
})();

// NOTE (2026-06-12): the old DROP 99 countdown/preview-lock code that used to live
// below this point was removed — it was hard-coded to the 2026-03-25 drop and had
// been dead since a missing-semicolon syntax error anyway. See
// THEME_MOBILE_FIXES_CHANGE_LOG.md in the Kit Drop Tool repo for the full backup.
